import Vue from 'vue';
import { getMyAwards } from './api';
import { TAB_REWARD_TYPE } from './constants';

// 我的奖品页
export default {
  namespaced: true,
  state() {
    return {
      awardsList: null
    };
  },
  actions: {
    async getAwardsList({ commit }) {
      Vue.prototype.$hll.showLoading({});
      let result = [];
      try {
        result = await getMyAwards({
          rewardType: TAB_REWARD_TYPE.AWARDS_RECORD
        });
      } catch (error) {
        Vue.prototype.$hll.toast(error && error.msg);
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
      commit('updateAwardsData', result);
    }
  },
  mutations: {
    updateAwardsData(state, data) {
      state.awardsList = data;
    }
  }
};
